import moment from 'jalali-moment';
import { MEDIA } from 'service/routes';

export const themeIdToStr = id => {
    if (id === 1)
        return "light";
    else if (id === 2)
        return "dark";
    else if (id === 3)
        return "primary-c";

    return null;
}

export const calculatePagination = (totalPages, currentPage) => {
    let startPoint = currentPage - 3;
    let endPoint = currentPage + 2;

    if (startPoint < 0)
        endPoint += startPoint * -1;

    let finalStartPoint = startPoint < 0 ? 1 : startPoint + 1;

    if (endPoint > totalPages) {
        const largerThanFromTotalPages = endPoint - totalPages;
        endPoint -= largerThanFromTotalPages;

        const tempFinalStartPoint = finalStartPoint - largerThanFromTotalPages;
        if (tempFinalStartPoint >= 1)
            finalStartPoint = tempFinalStartPoint;
    }

    return {
        start: finalStartPoint,
        end: endPoint
    }
}

export const addZeroToNum = num => {
    return num < 10 ? `0${num}` : `${num}`;
}

export const urlEncoder = url => {
    return encodeURIComponent(url);
}

export const urlDecoder = url => {
    return decodeURIComponent(url);
}

export const getFilename = url => {
    const filename = url.split('/').pop();
    return filename;
}

export const generateIconLink = (rowData, url) => {
    const results = url.match(/([:])\w+/g);

    if (results && results.length) {
        let newUrl = url;

        results.forEach(el => {
            const withoutDot = el.replace(":", "");
            const value = rowData[withoutDot];

            if (value)
                newUrl = newUrl.replace(el, value);
        })

        return newUrl;
    }

    return url;
}

export const isJson = value => {
    try {
        if (value) {
            JSON.parse(value);
            return true;
        }

        throw Object.assign(
            new Error(),
            { code: 402 }
        );
    } catch (e) {
        return false;
    }
}

export const toMoneyFormat = number => {
    try {
        return (Math.round(number * 100) / 100).toLocaleString();
    } catch {
        return "";
    }
}

export const faNumToEng = num => {
    let output = num.replaceAll('۰', '0');
    output = output.replaceAll('۱', '1');
    output = output.replaceAll('۲', '2');
    output = output.replaceAll('۳', '3');
    output = output.replaceAll('۴', '4');
    output = output.replaceAll('۵', '5');
    output = output.replaceAll('۶', '6');
    output = output.replaceAll('۷', '7');
    output = output.replaceAll('۸', '8');
    output = output.replaceAll('۹', '9');

    return output;
}

export const getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min);
}

export const isObject = value => {
    return value !== null && typeof value === "object" && !Array.isArray(value)
}

export const convertShamsiToUnix = (datetime, time = false) => {
    try {
        let jalaiFormat, miladiFormat;

        if (time) {
            jalaiFormat = 'jYYYY/jM/jD HH:mm:ss';
            miladiFormat = 'YYYY/M/D HH:mm:ss';
        } else {
            jalaiFormat = 'jYYYY/jM/jD';
            miladiFormat = 'YYYY/M/D';
        }

        const m = moment(datetime, jalaiFormat);
        const date = new Date(m.format(miladiFormat));
        return Math.floor(date.getTime() / 1000);
    } catch {
        return null;
    }
}

export const calculateDiscountPercentage = (originalPrice, discountedPrice) => {
    if (discountedPrice > originalPrice)
        return 0;

    const discountPercentage = ((originalPrice - discountedPrice) / originalPrice) * 100;
    return Math.ceil(discountPercentage)
}

export const timeToMinutes = time => {
    const splitedData = time.split(":");
    const hour = parseInt(splitedData[0]);
    const minute = parseInt(splitedData[1]);

    return hour * 60 + minute;
}

export const minutesToTime = num => {
    const hours = Math.floor(num / 60);
    const minutes = num % 60;

    return `${hours}:${minutes}`;
}

export const getProductImage = (url, cropSize = "org") => {
    try {
        if (url?.length) {
            let output = url.split(";")[0];
            output = output.replaceAll("org", cropSize);
            output = `${MEDIA}${output.replace("/storage", "")}`;

            return output;
        }

        throw Object.assign(new Error());
    } catch {
        return `${MEDIA}/public/${cropSize}/default.jpg`;
    }
}

export const unixToShamsi = (unix, showTime = true) => {
    try {
        if (!unix || isNaN(unix))
            throw new Error("invalid Unix");

        const monthes = [
            "فروردین",
            "اردیبهشت",
            "خرداد",
            "تیر",
            "مرداد",
            "شهریور",
            "مهر",
            "آبان",
            "آذر",
            "دی",
            "بهمن",
            "اسفند"
        ];

        const m = moment.unix(unix);
        let output = `${m.format("jD")} ${monthes[parseInt(m.format("jM")) - 1]} ${m.format("jYYYY")}`;

        if (showTime)
            output += ` - ساعت ${m.format("hh:mm")}`;

        return output;
    } catch {
        return "---";
    }
}

export const commentStatus = status => {
    switch (status) {
        case 0:
            return "در انتظار تایید";
        case 1:
            return "تایید شده";
        case 2:
            return "رد شده";
        case 3:
            return "حذف شده";
        default:
            return "";
    }
}

export const contentStatusId = status => {
    switch (status) {
        case 0:
            return {
                title: "در انتظار تایید",
                icon: <i className="fa-regular fa-hourglass-clock status active" title="در انتظار تایید"></i>
            };
        case 1:
            return {
                title: "تایید شده",
                icon: <i className="fa-solid fa-check status active" title="تایید شده"></i>
            }
        case 2:
            return {
                title: "رد شده",
                icon: <i className="fa-solid fa-xmark status deactive" title="رد شده"></i>
            }
        case 3:
            return {
                title: "حذف شده",
                icon: <i className="fa-regular fa-trash status deactive" title="حذف شده"></i>
            }
        case 4:
            return {
                title: "پیش نویس",
                icon: <i className="fa-regular fa-hourglass-clock status active" title="پیش نویس"></i>
            }
        default:
            return {
                title: "",
                icon: <></>
            }
    }
}

export const checkPermission = (list, permissions) => {
    if (permissions.all_access)
        return true;

    if (!list?.length > 0 || !permissions.routes_map)
        return false;

    const isIgnored = list.some(routeEl => !permissions.routes_map[routeEl]);
    return !isIgnored;
}

export const getStartOfDayUnix = unix => {
    const timeObj = moment.unix(unix);
    const hourse = parseInt(timeObj.format("H"));
    const minute = parseInt(timeObj.format("m"));
    const second = parseInt(timeObj.format("s"));

    return unix - (hourse * 3600) - (minute * 60) - second;
}

export const generateContentTitle = (formId, dataFields, formsEnum) => {
    let title = "بدون عنوان";

    const intendedForm = formsEnum.find(form => form.id === formId);
    if (intendedForm && intendedForm.label) {
        const labels = intendedForm.label.split(",").map(label => {
            if (label.indexOf('"') !== -1)
                return label.replaceAll('"', "");
            else
                return dataFields[label] || "";
        });

        title = labels.join("");
    }

    return title;
}

export const resolveAndDownloadBlob = (response, filename) => {
    let finalFilename = `${filename}.xlsx`;
    finalFilename = decodeURI(finalFilename);

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');

    link.href = url;
    link.setAttribute('download', finalFilename);
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(url);
    link.remove();
}

export const nowTimestamp = () => {
    return Math.floor(Date.now() / 1000);
}

export const secondToMin = second => {
    if (isNaN(second))
        return "00:00";

    const mins = parseInt(second / 60);
    const seconds = second % 60;

    return `${addZeroToNum(mins)}:${addZeroToNum(seconds)}`;
}